var _defs, _rect, _rect2, _polygon, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 81.67 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#414042;}.b{fill:url(#a);}.c{fill:#2c3582;}.d{fill:#faa71b;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 40.33,
    y1: 6.3,
    x2: 40.33,
    y2: 65.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f2f2f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#e1e2e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#cacbcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Visa_shadow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 1,
    width: 80.67,
    height: 50,
    rx: 11,
    ry: 11
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 80.67,
    height: 50,
    rx: 11,
    ry: 11
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "29.41 34.98 32.87 14.69 38.4 14.69 34.94 34.98 29.41 34.98"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M55,15.19a14.29,14.29,0,0,0-5-.85c-5.47,0-9.32,2.75-9.35,6.7,0,2.92,2.75,4.54,4.85,5.51s2.88,1.63,2.87,2.52c0,1.36-1.72,2-3.31,2A11.6,11.6,0,0,1,39.89,30l-.71-.32L38.4,34.2a17.52,17.52,0,0,0,6.16,1.08c5.82,0,9.59-2.72,9.63-6.93,0-2.31-1.45-4.07-4.64-5.51-1.93-.94-3.12-1.57-3.11-2.52s1-1.75,3.17-1.75a10.21,10.21,0,0,1,4.14.78l.5.23.75-4.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M69.19,14.71H64.91A2.75,2.75,0,0,0,62,16.39L53.8,35h5.81s.95-2.5,1.16-3.05h7.09c.17.71.67,3,.67,3h5.13L69.19,14.71M62.37,27.79l2.2-5.67c0,.05.45-1.18.73-1.94l.37,1.75L67,27.79H62.37Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M24.77,14.7,19.35,28.54l-.58-2.81a15.84,15.84,0,0,0-7.66-8.51l5,17.75h5.85L30.63,14.7H24.77"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M14.32,14.69H5.4l-.07.42c6.94,1.68,11.53,5.74,13.44,10.62L16.83,16.4a2.32,2.32,0,0,0-2.51-1.71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.c848a009353313459478dfb6567ec1fc.svg";
export { ForwardRef as ReactComponent };